import { FC } from 'react';
import { useIntl } from 'react-intl';
import styled from 'styled-components';
import Skeleton from '@material-ui/lab/Skeleton';
import { borderRadius, layoutStyles } from '../Theme';

const Container = styled.div`
  ${layoutStyles}
  margin-top: 4rem;
  left: 0;
  right: 0;
`;

const Hero = styled.div`
  display: flex;
  align-items: center;

  div {
    flex: 1;
    padding-left: 2rem;

    span:first-child {
      margin-top: -0.5rem;
      margin-bottom: 0.5rem;
      font-size: 2.8rem;
    }
  }
`;

const Content = styled.div`
  margin-top: 2rem;
  height: calc(100vh + 4rem);
`;

export const CompanySkeleton: FC = () => {
  const intl = useIntl();

  const loadingAriaLabel = intl.formatMessage({
    id: 'company.loadingAriaLabel',
    defaultMessage: 'Ladataan...',
  });

  return (
    <>
      <span role="alert" aria-busy="true" aria-label={loadingAriaLabel} />

      <Container aria-hidden>
        <Hero>
          <Skeleton animation="wave" width={96} height={96} style={{ transform: 'none', borderRadius, margin: 0 }} />

          <div>
            <Skeleton animation="wave" width="40%" />
            <Skeleton animation="wave" width="17%" />
          </div>

          <Skeleton
            className="icon"
            animation="wave"
            width={48 * 3}
            height={48}
            style={{ transform: 'none', borderRadius: 48, margin: 0 }}
          />
        </Hero>

        <Content>
          <Skeleton animation="wave" width="100%" height="100%" style={{ transform: 'none', borderRadius, margin: 0 }} />
        </Content>
      </Container>
    </>
  );
};
